module.exports = __webpack_public_path__ + "static/media/desom.b1bb1f51.png";